import { Badge } from '@/components/ui/badge';
import { describeTrackingStatus } from '@/lib/tracking-status';

/** Nothing is shown for a label that has never been checked: a badge reading "unknown" would only worry people. */
export default function TrackingBadge({ status, className = '' }) {
  if (!status) return null;
  const { label, tone } = describeTrackingStatus(status);

  return (
    <Badge variant="outline" className={`font-normal shrink-0 ${tone} ${className}`}>
      {label}
    </Badge>
  );
}
